module.exports = __webpack_public_path__ + "images/table_no.svg?d5021999";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/table_no.svg
// module id = 241
// module chunks = 7